import { computed } from "vue";

/** 调试用：为 true 时全局 loading 常显，调完改回 false */
const DEBUG_ALWAYS_SHOW = false;

/** 超过该延迟才显示；0 = 立即显示 */
const DELAY_MS = 0;

/** 最短展示时间，避免快切时闪一下却看不见 */
const MIN_SHOW_MS = 280;

/** 模块级单例，保证 app / plugin 共用同一状态 */
const state = {
	pendingCount: 0,
	visible: false,
	showTimer: null,
	hideTimer: null,
	shownAt: 0,
};

function clearShowTimer() {
	if (state.showTimer != null) {
		clearTimeout(state.showTimer);
		state.showTimer = null;
	}
}

function clearHideTimer() {
	if (state.hideTimer != null) {
		clearTimeout(state.hideTimer);
		state.hideTimer = null;
	}
}

function showNow(visibleRef) {
	clearHideTimer();
	state.visible = true;
	state.shownAt = Date.now();
	visibleRef.value = true;
}

function hideNow(visibleRef) {
	clearShowTimer();
	clearHideTimer();
	state.visible = false;
	state.shownAt = 0;
	visibleRef.value = false;
}

function syncVisible(visibleRef) {
	if (state.pendingCount > 0) {
		clearHideTimer();
		if (state.visible) return;
		if (state.showTimer != null) return;
		if (DELAY_MS <= 0) {
			showNow(visibleRef);
			return;
		}
		state.showTimer = setTimeout(() => {
			state.showTimer = null;
			if (state.pendingCount > 0) {
				showNow(visibleRef);
			}
		}, DELAY_MS);
		return;
	}

	clearShowTimer();
	if (!state.visible) {
		visibleRef.value = false;
		return;
	}

	const elapsed = Date.now() - state.shownAt;
	const remain = Math.max(0, MIN_SHOW_MS - elapsed);
	if (remain <= 0) {
		hideNow(visibleRef);
		return;
	}

	clearHideTimer();
	state.hideTimer = setTimeout(() => {
		state.hideTimer = null;
		if (state.pendingCount <= 0) {
			hideNow(visibleRef);
		}
	}, remain);
}

export function usePageLoading() {
	const visible = useState("global-page-loading-visible", () => DEBUG_ALWAYS_SHOW);

	const start = () => {
		if (!import.meta.client) return;
		if (DEBUG_ALWAYS_SHOW) return;
		state.pendingCount += 1;
		syncVisible(visible);
	};

	const stop = () => {
		if (!import.meta.client) return;
		if (DEBUG_ALWAYS_SHOW) return;
		state.pendingCount = Math.max(0, state.pendingCount - 1);
		syncVisible(visible);
	};

	const forceStop = () => {
		if (!import.meta.client) return;
		if (DEBUG_ALWAYS_SHOW) return;
		state.pendingCount = 0;
		syncVisible(visible);
	};

	return {
		isPageLoading: computed(() => DEBUG_ALWAYS_SHOW || visible.value),
		startPageLoading: start,
		stopPageLoading: stop,
		forceStopPageLoading: forceStop,
	};
}
